import ActionButton from '../components/buttons/action-button'
import truncate from 'lodash/truncate'
const TITLE_TRUNCATED_LENGTH = 60

export const listItemMixin = {
  components: {
    ActionButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    actionUrl: {
      type: String,
      required: true
    },
    colorIndex: {
      type: Number,
      required: true
    }
  },

  computed: {
    displayTitle() {
      return truncate(this.title, { 'length': TITLE_TRUNCATED_LENGTH })
    }
  }
}
